import React, { useMemo, useState } from "react";

const ReportesDashboard = () => {
  const [filtros, setFiltros] = useState({
    fechaInicio: "",
    fechaFin: "",
    modulo: "",
    estado: "",
  });

  const colores = {
    fondo: "linear-gradient(135deg, #0e1319 0%, #212529 40%, #0d6efd 100%)",
    azul: "#0d6efd",
  };

  const estadisticas = useMemo(
    () => [
      {
        titulo: "Aprendices",
        valor: 245,
        icono: "fa-user-graduate",
        descripcion: "Registrados en el sistema",
      },
      {
        titulo: "Instructores",
        valor: 18,
        icono: "fa-chalkboard-user",
        descripcion: "Activos actualmente",
      },
      {
        titulo: "Contratos",
        valor: 32,
        icono: "fa-file-contract",
        descripcion: "Contratos registrados",
      },
      {
        titulo: "Seguimientos",
        valor: 128,
        icono: "fa-clipboard-check",
        descripcion: "Procesos realizados",
      },
    ],
    []
  );

  const reportes = useMemo(
    () => [
      {
        titulo: "Reporte de Aprendices",
        descripcion: "Listado general por ficha, programa, estado y etapa.",
        icono: "fa-user-graduate",
      },
      {
        titulo: "Reporte de Instructores",
        descripcion: "Contratos, obligaciones, agendas e informes asociados.",
        icono: "fa-chalkboard-user",
      },
      {
        titulo: "Reporte de Etapa Productiva",
        descripcion: "Seguimientos, bitácoras, estados y avances.",
        icono: "fa-briefcase",
      },
      {
        titulo: "Reporte de Asistencia",
        descripcion: "Control de asistencia por fecha, ficha o instructor.",
        icono: "fa-calendar-check",
      },
      {
        titulo: "Reporte de Contratos",
        descripcion: "Contratos activos, vencidos o próximos a vencer.",
        icono: "fa-file-contract",
      },
      {
        titulo: "Reporte de Actas",
        descripcion: "Actas generadas por grupo, ficha o programa.",
        icono: "fa-file-signature",
      },
    ],
    []
  );

  const handleChange = (e) => {
    setFiltros({
      ...filtros,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="bg-body-tertiary min-vh-100 py-4">
      <div className="container-fluid px-2 px-md-4">

        <div
          className="rounded-4 shadow-sm p-4 mb-4 text-white"
          style={{ background: colores.fondo }}
        >
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
            <div>
              <span className="badge bg-white text-dark rounded-pill px-3 py-2 mb-3">
                Panel ejecutivo
              </span>

              <h2 className="fw-bold mb-1">Centro de Reportes</h2>

              <p className="mb-0 opacity-75">
                Consulta, filtra y analiza la información institucional del sistema.
              </p>
            </div>

            <button className="btn btn-light fw-semibold">
              <i className="fa-solid fa-file-export me-2"></i>
              Exportar
            </button>
          </div>
        </div>

        <div className="row g-3 mb-4">
          {estadisticas.map((item, index) => (
            <div className="col-12 col-md-6 col-xl-3" key={index}>
              <div className="bg-white border rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-4 text-white d-flex align-items-center justify-content-center"
                    style={{
                      width: 55,
                      height: 55,
                      background:
                        "linear-gradient(135deg, #212529 0%, #0d6efd 100%)",
                    }}
                  >
                    <i className={`fa-solid ${item.icono}`}></i>
                  </div>

                  <div>
                    <div className="small text-secondary">{item.titulo}</div>
                    <h4 className="fw-bold mb-0">{item.valor}</h4>
                    <small className="text-secondary">{item.descripcion}</small>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white border rounded-4 shadow-sm p-3 p-md-4 mb-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <h5 className="fw-bold mb-1" style={{ color: colores.azul }}>
                Filtros de consulta
              </h5>
              <p className="text-secondary small mb-0">
                Selecciona los criterios para consultar la información.
              </p>
            </div>

            <button className="btn btn-outline-secondary">
              <i className="fa-solid fa-rotate me-2"></i>
              Limpiar
            </button>
          </div>

          <hr />

          <div className="row g-3">
            <div className="col-12 col-md-3">
              <label className="form-label small text-secondary text-uppercase">
                Fecha inicio
              </label>
              <input
                type="date"
                className="form-control"
                name="fechaInicio"
                value={filtros.fechaInicio}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small text-secondary text-uppercase">
                Fecha fin
              </label>
              <input
                type="date"
                className="form-control"
                name="fechaFin"
                value={filtros.fechaFin}
                onChange={handleChange}
              />
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small text-secondary text-uppercase">
                Módulo
              </label>
              <select
                className="form-select"
                name="modulo"
                value={filtros.modulo}
                onChange={handleChange}
              >
                <option value="">Todos</option>
                <option value="aprendices">Aprendices</option>
                <option value="instructores">Instructores</option>
                <option value="contratos">Contratos</option>
                <option value="etapa">Etapa productiva</option>
                <option value="asistencia">Asistencia</option>
              </select>
            </div>

            <div className="col-12 col-md-3">
              <label className="form-label small text-secondary text-uppercase">
                Estado
              </label>
              <select
                className="form-select"
                name="estado"
                value={filtros.estado}
                onChange={handleChange}
              >
                <option value="">Todos</option>
                <option value="activo">Activo</option>
                <option value="pendiente">Pendiente</option>
                <option value="finalizado">Finalizado</option>
                <option value="vencido">Vencido</option>
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button className="btn btn-dark fw-semibold">
              <i className="fa-solid fa-magnifying-glass-chart me-2"></i>
              Consultar reporte
            </button>
          </div>
        </div>

        <div className="row g-4">
          {reportes.map((reporte, index) => (
            <div className="col-12 col-md-6 col-xl-4" key={index}>
              <div className="bg-white border rounded-4 shadow-sm p-4 h-100">
                <div
                  className="rounded-4 text-white d-flex align-items-center justify-content-center mb-3"
                  style={{
                    width: 58,
                    height: 58,
                    background: colores.fondo,
                  }}
                >
                  <i className={`fa-solid ${reporte.icono} fs-4`}></i>
                </div>

                <h5 className="fw-bold mb-2">{reporte.titulo}</h5>

                <p className="text-secondary small">
                  {reporte.descripcion}
                </p>

                <div className="d-flex gap-2 flex-wrap mt-3">
                  <button className="btn btn-outline-primary btn-sm">
                    <i className="fa-solid fa-eye me-2"></i>
                    Ver
                  </button>

                  <button className="btn btn-outline-success btn-sm">
                    <i className="fa-solid fa-file-excel me-2"></i>
                    Excel
                  </button>

                  <button className="btn btn-outline-danger btn-sm">
                    <i className="fa-solid fa-file-pdf me-2"></i>
                    PDF
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ReportesDashboard;